import React from 'react'

const AnimatedDots = (props) => {
  return (
    <span className='saving'><span>.</span><span>.</span><span>.</span></span>
  )
}

export default AnimatedDots
